import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  display: ${(props) => (props.$isActive ? "flex" : "none")};
  flex-direction: column;

  .indicator-bar {
    width: 2px;
    height: 30px;
    background-color: ${(props) => {
      switch (props.$backgroundColor) {
        case "declinedThemeColour":
          return palette("tracking", 3);
        case "white":
          return palette("color", 16);
        case "mainThemeColor":
        default:
          return palette("tracking", 2);
      }
    }};
    align-self: center;
  }

  .indicator-status {
    display: ${(props) => (props.$showIndicatorStatus ? "block" : "none")};
    background-color: ${(props) => {
      switch (props.$backgroundColor) {
        case "declinedThemeColour":
          return palette("tracking", 3);
        case "white":
          return palette("tracking", 4);
        case "mainThemeColor":
        default:
          return palette("tracking", 4);
      }
    }};
    padding: 8px 12px;
    border-radius: 25px;
    align-self: center;
    color: #fff;
    text-align: center;

    span {
      color: #f8ea12;
      font-weight: bold;
    }
  }
`;
